import { useContext, useState, useEffect } from "react";
import AppContext from "../contexts/AppContext";
import NavBar from "../components/appbar/NavBar";
import { Alert, Box, Grid, Stack, Typography, Divider } from "@mui/material";
import EventCard from "../components/card/EventCard";
import DKPEarnedTable from "../components/home/DKPEarnedTable"
import apiFetch from "../helperFunctions/api";

export default function PersonalPage(props) {
  const [itemsWon, setItemsWon] = useState([]);
  const [dkpEarned, setdkpEarned] = useState([])
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const { character } = props;

  let { API, raidTeams } = useContext(AppContext);
  const team = raidTeams.find((candidate) => candidate.id === character.raid_team);
  const raidTeamName = team ? `${team.name} Raid` : character.raid_team ? "Loading raid team..." : "Unassigned";

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    setItemsWon([]);
    setdkpEarned([]);
    apiFetch(`${API}/ledger/${encodeURIComponent(character.name)}`)
      .then((response) => response.json())
      .then((data) => {
        if (!active) return;
        const sorted = [...data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setItemsWon(sorted.filter((entry) => Number(entry.itemId) !== 0));
        setdkpEarned(sorted.filter((entry) => Number(entry.itemId) === 0));
      })
      .catch((err) => {
        console.error("Unable to load character history:", err);
        if (active) setError(err.message);
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [API, character.name]);

  return (
    <>
      <NavBar pageName={`${character.name}`} />
      {error && <Alert severity="error">{error}</Alert>}
      {loading && <Typography>Loading character history...</Typography>}
      <Box sx={{ flexGrow: 1, p: 4 }}>
        <Grid justifyContent="flex-start" container spacing={0.75}>
          <Grid item xs={12} sm={6}>
            <Box sx={{textAlign: 'center', maxHeight: 440}}>
            <Stack direction="column" alignContent="center" spacing={2}>
              <Typography variant="h4">
              {character.characterClass} {character.name}
              </Typography>
              <Divider orientation="horizontal" flexItem />
              <Typography variant="h4">
                DKP: {character.dkp}
              </Typography>
              <Divider orientation="horizontal" flexItem />
              <Typography variant="h4">
                {raidTeamName}
              </Typography>
            </Stack>
            </Box>
          </Grid>
          {!loading && !error && <Grid item xs={12} sm={6}>
            <DKPEarnedTable dkpGain={dkpEarned} />
          </Grid>}
          {!loading && !error && itemsWon.map((item) => (
            <Grid key={item.id} item xs={12} sm={6} md={3} lg={3} xl={2}>
              <EventCard character={character} cardData={item} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}
